import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ContentService } from '../../services/content.service';
import { QuestionnaireService } from '../../services/questionnaire.service';

@Component({
  selector: 'app-confirm-modal',

  templateUrl: './confirm-modal.component.html',
  styleUrl: './confirm-modal.component.scss'
})
export class ConfirmModalComponent {
  @Input() title ='Confirm'; 
  @Input() message: string | undefined;
  @Input() appointmentId: string | undefined;
  @Input() donorEmail?: string;
  @Input() actionType: 'deleteAppointment' | 'resetQuestionnaire' | 'confirm' | 'info' | 'profileName' = 'deleteAppointment';
  @Input() confirmButtonText = 'Confirm';
  @Input() cancelButtonText = 'Cancel';
  @Input() closeButtonText = 'OK';
  @Input() firstName = '';
  @Input() lastName = '';
  @Input() firstNameLabel = 'First name';
  @Input() lastNameLabel = 'Last name';
  @Input() requiredErrorText = 'Please enter both first and last name.';

  isDeleting = false;
  isResetting = false;
  showRequiredError = false;

  constructor(public activeModal: NgbActiveModal, private contentService: ContentService, private questionsService: QuestionnaireService) {}

  deleteAppointment() {
    this.isDeleting = true;
    if (this.appointmentId) {
      this.contentService.deleteAppointment(this.appointmentId).subscribe({
        next: (response) => {
          this.isDeleting = false;
          this.activeModal.close({ action: 'deleteAppointment', response });
        },
        error: (err) => {
          console.error('Error deleting appointment:', err);
          this.isDeleting = false;
        },
      });
    }
  }

  resetDonorQuestionnaire() {
    this.isResetting = true;
    if (!this.donorEmail) {
      this.isResetting = false;
      return;
    }

    this.questionsService.resetQuestionnaireByUserId(this.donorEmail).subscribe({
      next: (response) => {
        this.isResetting = false;
        this.activeModal.close({ action: 'resetQuestionnaire', response, donorEmail: this.donorEmail });
      },
      error: (err) => {
        console.error('Error resetting questionnaire:', err);
        this.isResetting = false;
        // Keep the modal open so the user can retry or cancel
      },
    });
  }

  confirm() {
    this.activeModal.close({ action: 'confirm' });
  }

  submitProfileName() {
    const firstName = this.firstName.trim();
    const lastName = this.lastName.trim();

    if (!firstName || !lastName) {
      this.showRequiredError = true;
      return;
    }

    this.activeModal.close({
      action: 'profileName',
      firstName,
      lastName,
    });
  }
}
